import { IonButton } from '@ionic/react';
import classNames from 'classnames';

import styles from './Button.module.scss';

interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  color?: 'primary' | 'dark' | 'medium' | 'danger' | 'warning' | 'success' | undefined;
  disabled?: boolean;
  expand?: boolean | undefined;
  fill?: 'default' | 'clear' | 'outline' | 'solid' | undefined;
  id: string;
  onClick: () => void;
  size?: 'small' | 'medium' | 'large' | undefined;
  type?: 'submit' | 'reset' | 'button' | undefined;
  shape?: 'round' | undefined;
}

export default function Button({
  children,
  className = undefined,
  color = 'primary',
  disabled = undefined,
  expand = undefined,
  fill = undefined,
  id,
  onClick,
  size = undefined,
  type = 'button',
  shape = undefined,
}: ButtonProps) {
  return (
    <IonButton
      className={classNames(styles.button, className, {
        [styles.small]: size === 'small',
        [styles.medium]: size === 'medium',
      })}
      color={color}
      disabled={disabled}
      expand={expand ? 'block' : undefined}
      fill={fill}
      id={id}
      onClick={onClick}
      type={type}
      shape={shape}
    >
      <span>{children}</span>
    </IonButton>
  );
}
